import { all } from 'redux-saga/effects';
import loginSaga from './auth/saga';
import LayoutSaga from './layout/saga';
import notificationSaga from './notification/saga';

export default function* rootSaga() {
	yield all([loginSaga(), LayoutSaga(), notificationSaga()]);
}
